import React, { useState, useEffect } from 'react';

export default function MatrixCell({ value, column, cell }) {
  const [showModal, setShowModal] = useState(false);

  if (!value || value !== 'has_matrix') return <span />;

  const matrixData = cell.matrix || [];
  const columns = column.matrix_columns || [];
  const matrixType = column.matrix_type || 'radio';
  const hasComments = column.matrix_has_comments;
  const hasFile = column.matrix_has_file;

  useEffect(() => {
    if (!showModal) return;
    const handleKey = (e) => { if (e.key === 'Escape') setShowModal(false); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [showModal]);

  return (
    <>
      <span className="cm-cell-matrix-link" onClick={(e) => { e.stopPropagation(); setShowModal(true); }}>
        <i className="fas fa-th" /> Ver matriz
      </span>
      {showModal && (
        <div className="cm-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="cm-modal-matrix" onClick={e => e.stopPropagation()}>
            <div className="cm-modal-matrix__header">
              <span className="cm-modal-matrix__title">{column.name}</span>
              <button className="cm-modal-richtext__close" onClick={() => setShowModal(false)}>
                <i className="fas fa-times" />
              </button>
            </div>
            <div className="cm-modal-matrix__body">
              <table className="cm-matrix-table">
                <thead>
                  <tr>
                    <th>Fila</th>
                    {matrixType === 'number' ? (
                      <th className="text-center">Calificación</th>
                    ) : (
                      columns.map((col, i) => (
                        <th key={i} className="text-center">{col}</th>
                      ))
                    )}
                    {hasFile && <th>Evidencia</th>}
                    {hasComments && <th>Comentarios</th>}
                  </tr>
                </thead>
                <tbody>
                  {matrixData.map((row, i) => (
                    <tr key={i}>
                      <td>
                        {row.name}
                        {row.description && <span className="cm-matrix-desc">{row.description}</span>}
                      </td>
                      {matrixType === 'number' ? (
                        <td className="text-center">{row.value}</td>
                      ) : (
                        columns.map((col, j) => (
                          <td key={j} className="text-center">
                            {matrixType === 'checkbox' ? (
                              row.value && row.value.includes(col) ? <i className="fas fa-check-square" style={{ color: 'var(--cm-primary)' }} /> : <i className="far fa-square" style={{ color: '#ccc' }} />
                            ) : (
                              row.value === col ? <i className="fas fa-check-circle" style={{ color: 'var(--cm-primary)' }} /> : <i className="far fa-circle" style={{ color: '#ccc' }} />
                            )}
                          </td>
                        ))
                      )}
                      {hasFile && (
                        <td className="text-center">
                          {row.url ? (
                            <a href={row.url} target="_blank" rel="noopener noreferrer" className="cm-cell-file-link">
                              <i className="fas fa-file" /> Ver archivo
                            </a>
                          ) : (
                            <span style={{ color: '#ccc', fontSize: 12 }}>—</span>
                          )}
                        </td>
                      )}
                      {hasComments && <td className="cm-matrix-comment">{row.comments || ''}</td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
